<template>
  <img
    v-if="url"
    ref="image"
    :class="classes"
    v-bind="$attrs"
    :style="spreadedStyles"
    :src="url"
    v-on="$listeners"
    @load="$emit('done')"
  />
  <div v-else class="placeholder-container">
    <div class="placeholder-img"></div>
    <p>{{ $t('proposition_missing_image_text') }}</p>
  </div>
</template>

<script>
export default {
  name: 'AImage',

  props: {
    url: {
      type: String,
      required: false,
      default: null
    },

    classes: {
      type: Array,
      default: () => [],
      required: false
    },

    styles: {
      type: Array,
      default: () => [],
      required: false
    }
  },

  computed: {
    spreadedStyles() {
      return [...this.styles];
    }
  }
};
</script>

<style lang="scss" scoped>
.placeholder-container {
  position: relative;
  background-color: #f7f7f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 200px;

  .placeholder-img {
    background-position: 50%;
    background-color: #f7f7f9;
    background-size: 50%;
    background-image: url('../../../assets/svg/placeholderImage/placeholder-image-large.svg');
    object-fit: cover;
    display: block;
    height: 100%;
    width: 100%;
  }

  p {
    font-size: 12px;
    text-align: center;
    margin: 0;
    position: absolute;
    top: 70%;
    z-index: 1;
  }
}
</style>
